import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react';
import CustomTableWithFilter from '../../../ReUsableComponent/CustomTableWithFilter';
import CustomModal from '../../../ReUsableComponent/CustomModal';
import CustomBlueButton from '../../../ReUsableComponent/CustomBlueButton';
import { ReconReportHeader } from '../../TableHeaders';
import { brandManagementActions } from '../../../store/reducers/BrandManagementReducer';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import CloseIcon from '../../../assets/svg/closeIconofmodal.svg';
import SuccessPopup from '../../../ReUsableComponent/SuccessPopupMsg';
import Loader from '../../../ReUsableComponent/Loader';
import { ToastErrorService, ToastSuccessService } from '../../../ReUsableComponent/ToastNotification/ToastService';
import dropDownIcon from '../../../assets/svg/dropDownIcon.svg';
import { GetBrandNameList, GetStoreCustomerNameList } from '../../RuleManagement/RuleManagement.service';
import { salesActions } from '../../../store/reducers/SalesOverviewReducer';
import { CreateCustomReconReport, DownloadConsolidatedReportList, GetCustomReportList, GetReconStoreList, GetSalesReconData, RefreshAllReconReports, RefreshReconReports, RefreshUnprocssedReportList, SendReconReportByEmail } from '../SalesOverview.service';
import CustomFilterSearchDropdown from '../../../ReUsableComponent/CustomFilterSearchDropdown';
import CustomMonthYearPicker from '../../../ReUsableComponent/CustomMonthYearPicker';
import dayjs from 'dayjs';
import DownloadIcon from '../../../assets/svg/reportsDownload.svg';
import { InfoOutlined } from '@mui/icons-material';
import { differenceInDays, setHours, setMilliseconds, setMinutes, setSeconds } from 'date-fns';
import moment from 'moment';
import CustomDateRangePicker from '../../../ReUsableComponent/CustomDaterangePicker';
import MultiSelectCheckBox from '../../../ReUsableComponent/MultiSelectCheckBox';
import InputTextField from '../../../ReUsableComponent/InputTextField';
import CustomAutoComplete from '../../../ReUsableComponent/CustomAutocomplete';
import Checkbox from '@mui/material/Checkbox';
import { createPortal } from 'react-dom';

const downloadType = [{ label: 'Template Download', value: 'Template' }, { label: 'Report Download', value: 'Report' }]
const uploadFileModalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: '#F2F2F2',
    boxShadow: 24,
    p: '40px 32px',
    borderRadius: 6,
    border: '1px solid #3333330D'
};

const SuccessUploadModalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 390,
    bgcolor: '#F2F2F2',
    boxShadow: 24,
    p: '40px 32px',
    borderRadius: 6,
    border: '1px solid #3333330D'
};

const uploadedFileModalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 835,
    bgcolor: '#F2F2F2',
    boxShadow: 24,
    p: '40px 32px',
    borderRadius: 6,
    border: '1px solid #3333330D'
};

const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: 300,
            width: 'max-content',
        },
    },
}; 

const viewReportFileModalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: '#F2F2F2',
    boxShadow: 24,
    p: '40px 32px',
    borderRadius: 6,
    border: '1px solid #3333330D'
};


const MonthList = [{ label: 'January', value: 'January' }, { label: 'February', value: 'February' }, { label: 'March', value: 'March' }, { label: 'April', value: 'April' }, { label: 'May', value: 'May' },
{ label: 'June', value: 'June' }, { label: 'July', value: 'July' }, { label: 'August', value: 'August' }, { label: 'September', value: 'September' },
{ label: 'October', value: 'October' }, { label: 'November', value: 'November' }, { label: 'December', value: 'December' },
];

const ReconType = [
    { label: 'Reco - RS', value: 'Reco - RS' },
    { label: 'Reco - MC', value: 'Reco - MC' },
    { label: 'Reco - BS', value: 'Reco - BS' }
]

const ReconReport = () => {
    const gridRef = useRef(null);
    const today = new Date();
    const dispatch = useDispatch();
    const history = useHistory();
    const [loading, setLoading] = React.useState(false);
    const [viewAllInfo, setViewAllInfo] = useState(false);
    const [reconReportTableData, setReconReportTableData] = useState([]);
    const [openCustomReport, setOpenCustomReport] = useState(false);
    const [openSuccessPopup, setOpenSuccessPopup] = useState(false);
    const selectedPage = useSelector(state => state.brandManagement.selectedPageForMatser);
    const USER_TOKEN = useSelector((state) => state.userAuthentication.userToken);
    const [anchorElForBrand, setAnchorElForBrand] = useState(null);
    const openBrandFilter = Boolean(anchorElForBrand);
    const [selectedBrand, setSelectedBrand] = useState({ label: useSelector(state => state?.sales?.defaultBrandForRecon?.label), value: useSelector(state => state?.sales?.defaultBrandForRecon?.value) });
    const [brandList, setBrandList] = useState([]);
    const defaultBrand = useSelector(state => state?.sales?.defaultBrandForRecon);
    const itemMasterFilter = useSelector(state => state?.brandManagement?.masterFilter);
    const [dropSearchValue, setdropSearchValue] = useState('');
    const USER_ID = useSelector((state) => state.userAuthentication.userId);
    const [customReportData, setCustomReportData] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [gridApi, setGridApi] = useState(null);
    const [selectedItems, setSelectedItems] = useState([]);
    const convertDateIntoMonth = (dateString) => {
        let date = new Date(dateString);
        const year = date.getFullYear();
        const month = date.toLocaleString('default', { month: 'long' })
        return `${month}-${year}`;
    }
    const [inputValue, setInputValue] = useState({
        brand: [],
        store: [],
        report: 'Sales',
        service: 'good_sales',
        from_date: null,
        to_date: null,
        // recon: {}
    });
    const [startDate, setStartDate] = useState(inputValue?.from_date ? new Date(inputValue?.from_date) : null);
    const [endDate, setEndDate] = useState(inputValue?.to_date ? new Date(inputValue?.to_date) : null);
    const [selectedRange, setSelectedRange] = useState([
        inputValue?.from_date ? new Date(inputValue?.from_date) : today,
        inputValue?.to_date ? new Date(inputValue?.to_date) : null,
    ]);
    const [brandNameList, setBrandNameList] = useState([]);
    const [calendarOpen, setCalendarOpen] = useState(false);
    const [storeNameListForCustom, setStoreNameListForCustom] = useState([]);
    const [selectedItem, setSelectedItem] = useState({ description: '', id: '' });
    const [selectedMonthYear, setSelectedMonthYear] = useState(convertDateIntoMonth(new Date(useSelector(state => state?.sales?.defaultMonthForRecon))));
    const [hoverInfo, setHoverInfo] = useState(null); // { data, rect } or null
    const tooltipRef = useRef(null);
    const [tooltipPos, setTooltipPos] = useState({ top: 0, left: 0, ready: false });
    const [selectedTab, setSelectedTab] = useState(1);

    useEffect(() => {
        getAllBrand();
        customReportList();
        getStoreListForCustom();
        // getBrandList();
    }, [])
    useEffect(() => {
        getStoreList(defaultBrand?.value, selectedMonthYear)
    }, [defaultBrand, selectedMonthYear])

    useEffect(() => {
        getBrandList()
    }, [])

    useEffect(() => {
        let param = '';
        if (itemMasterFilter?.barcode) {
            param = param + `&barcode=${itemMasterFilter?.barcode?.filter}`;
        }
        if (itemMasterFilter?.styleCode) {
            param = param + `&style_code=${itemMasterFilter?.styleCode?.filter}`;
        }
        if (itemMasterFilter?.categoryDivision) {
            param = param + `&category_division=${itemMasterFilter?.categoryDivision?.filter}`;
        }
        if (itemMasterFilter?.categoryGroup) {
            param = param + `&category_group=${itemMasterFilter?.categoryGroup?.filter}`;
        }
        if (itemMasterFilter?.categorySection) {
            param = param + `&category_presence=${itemMasterFilter?.categorySection?.filter}`;
        }
    }, [selectedPage, defaultBrand, itemMasterFilter])

    useLayoutEffect(() => {
        if (!hoverInfo || !tooltipRef.current) {
            setTooltipPos((p) => (p.ready ? { top: 0, left: 0, ready: false } : p));
            return;
        }

        const GAP = 6;      // space between button and popup
        const MARGIN = 8;   // minimum distance from screen edges
        const { width, height } = tooltipRef.current.getBoundingClientRect();
        const { rect } = hoverInfo;

        // Vertical: prefer below, flip above if it doesn't fit
        let top = rect.bottom + GAP;
        if (top + height + MARGIN > window.innerHeight) {
            top = rect.top - height - GAP;
        }
        // Still doesn't fit above either: clamp to the screen
        top = Math.max(MARGIN, Math.min(top, window.innerHeight - height - MARGIN));

        // Horizontal: keep your "open to the left of the button" behaviour, then clamp
        let left = rect.left - 250;
        left = Math.max(MARGIN, Math.min(left, window.innerWidth - width - MARGIN));

        setTooltipPos({ top, left, ready: true });
    }, [hoverInfo]);

    const onGridReady = (params) => {
        gridRef.current = params.api;
        gridRef.current.sizeColumnsToFit();
        setGridApi(params.api);
    };

    const handleBrandClick = (event) => {
        setAnchorElForBrand(event.currentTarget);
    };
    const handleBrandClose = () => {
        setAnchorElForBrand(null);
    };

    const onSelectBrand = (event) => {
        brandList.forEach(brand => {
            if (event.target.value === brand?.value) {
                setSelectedBrand({ label: brand?.label, value: event.target.value })
                setAnchorElForBrand(null);
                dispatch(salesActions.setDefaultBrandForRecon({ type: brand }));
            }
        });
        // getStoreList(event.target.value)
    }

    const getAllBrand = () => {
        let param = `?user_id=${USER_ID}`
        GetBrandNameList(param, USER_TOKEN).then(response => {
            if (response.data.statusCode === 200) {
                let brands = []
                response.data.data.forEach(element => {
                    let brandObject = {
                        label: element.brand_name,
                        value: element._id
                    }
                    brands.push(brandObject)
                });
                setBrandList(brands);
            }
        }).catch(error => {
            if (error.response.status === 401) {
                history.push('/')
            }
            ToastErrorService(error.response.data.message);
        }).finally(() => {
        })
    }

    const getBrandList = () => {
        let param = `?user_id=${USER_ID}`
        // if (inputValue?.recon?.value) {
        //     param = param + `&reco_type=${inputValue?.recon?.value}`
        // }
        GetBrandNameList(param, USER_TOKEN).then(response => {
            let dropdownData = [];
            response?.data?.data?.map(item => {
                let row = {
                    label: item?.brand_name,
                    value: item?.brand_name,
                    brand_id: item?._id
                }
                dropdownData.push(row)
            })
            setBrandNameList(dropdownData);

        }).catch(error => {
            console.log(error)
        });
    }

    const valueCheck = (value) => {
        if (value && value !== 'null') {
            return value;
        } else {
            return '-';
        }
    }

    const getStoreList = (brand_id, month) => {
        setLoading(true);
        let param = `?brand_id=${brand_id}&report_month=${month}`;
        GetReconStoreList(USER_TOKEN, param).then(response => {
            let tableData = [];
            response?.data?.data?.map(item => {
                let row = {
                    codeStore: valueCheck(item?.store_details?.store_code),
                    nameStore: valueCheck((item?.store_details?.store_trade_name && item?.store_details?.store_trade_name !== 'null') ? item?.store_details?.store_trade_name : item?.store_details?.customer_name),
                    storeEmail: valueCheck(item?.store_details?.store_address?.email),
                    id: item?._id,
                    storeId: item?.store_id,
                    lastMailSent: convertDates(item?.store_details?.last_recon_mail_sent),
                    lastInvDate: convertDates(item?.report_invoice_date_range?.to_date),
                    updatedOn: convertDateTime(item?.created_at),
                    reconData: item?.recon_outstanding,
                }
                tableData.push(row)
            })
            setReconReportTableData(tableData);
        }).catch(error => {

        }).finally(() => {
            setLoading(false);
        })
    }

    const onFilterChanged = (event) => {
        let filterModel = event.api.getFilterModel();
        dispatch(brandManagementActions.setMasterFilter({ type: filterModel }))
    };

    const downloadReport = (event, action) => {
        setLoading(true);
        if (action === 'download') {
            let param = `?store=${event.data.storeId}&brand=${selectedBrand?.value}&report=Sales&service=recon`;
            if (event.colDef.field === 'reconFileDownload') {
                param = param + `&view_range=${selectedMonthYear}`
            } else {
                let currentYear = new Date().getFullYear()
                param = param + `&view_range=${currentYear}`
            }
            DownloadConsolidatedReportList(param, USER_TOKEN).then(response => {
                if (response.data.statusCode === 200) {
                    window.open(response.data.presignedFileUrl, '_blank');
                    ToastSuccessService('Sales report downloaded successfully.');
                } else if (response.data.statusCode === 400) {
                    ToastErrorService(response.data.message);
                }
            }).catch(error => {
                ToastErrorService(error?.response.data.message);
            }).finally(() => {
                setLoading(false);
            })
        } else {
            let param = `?store=${event.data.storeId}&brand=${selectedBrand?.value}&report=Sales&service=recon`;
            if (event.colDef.field === 'reconFileDownload') {
                param = param + `&view_range=${selectedMonthYear}`
            } else {
                let currentYear = new Date().getFullYear()
                param = param + `&view_range=${currentYear}`
            }
            RefreshReconReports(param, USER_TOKEN).then(response => {
                if (response.data.statusCode === 200) {
                    ToastSuccessService('Reports are being refreshed, please check after sometime.');
                } else if (response.data.statusCode === 400) {
                    ToastErrorService(response.data.message);
                }
            }).catch(error => {
                if (error.response.status === 401) {
                    history.push('/')
                }
                ToastErrorService(error.response.data.message);
            }).finally(() => {
                setLoading(false);
            })
        }
    }

    const onMouseOver = useCallback((data, rect) => {
        if (data?.reconData?.length > 0) {
            setHoverInfo({ data, rect });
        }
    }, []);

    const onMouseOut = useCallback(() => {
        setHoverInfo(null);
    }, []);

    const convertNumbersToReadableFormat = (value) => {
        const num = Number(value);
        if (value === null || value === undefined || value === '' || !Number.isFinite(num)) return '₹0';

        const formatted = Math.abs(num).toLocaleString('en-IN');
        return num < 0 ? `-₹${formatted}` : `₹${formatted}`;
    };

    const handleSearchChange = (event) => {
        setdropSearchValue(event.target.value);
    };

    const onMonthSelect = (value) => {
        setSelectedMonthYear(convertDateIntoMonth(value));
    }

    const onClickCreateCustomReport = () => {
        setOpenCustomReport(true);
        setInputValue({
            brand: [],
            store: [],
            report: 'Sales',
            service: 'good_sales',
            from_date: null,
            to_date: null
        })
        setStartDate(null);
        setEndDate(null);
    }

    const customReportList = () => {
        let param = '?view_range=Custom&report_type=recon'
        GetCustomReportList(param).then(response => {
            let rowdata = []
            response.data.data.forEach(item => {
                let row = {
                    description: item.description,
                    id: item._id,
                    from_date: item.from_date,
                    to_date: item.to_date,
                    created_at: item.created_at,
                }
                rowdata.push(row)
            })
            setCustomReportData(rowdata)
        }).catch(error => {
            console.log(error)
        }).finally(() => {

        })
    }

    function toUTCStartOfDay(date) {
        const localMidnight = setMilliseconds(setSeconds(setMinutes(setHours(date, 0), 0), 0), 0);
        return new Date(localMidnight.getTime() - localMidnight.getTimezoneOffset() * 60000);
    }

    function toUTCEndOfDay(date) {
        const localEndOfDay = setMilliseconds(setSeconds(setMinutes(setHours(date, 23), 59), 59), 999);
        return new Date(localEndOfDay.getTime() - localEndOfDay.getTimezoneOffset() * 60000);
    }

    const displayDescription = (item, from) => {
        let strToArray = item.description.split(",");
        if (from === 'table') {
            return <>
                <div className='ps-1'>{moment.utc(item.from_date).format("DD MMM YYYY")} - {moment.utc(item.to_date).format("DD MMM YYYY")}</div>
                <ol id='table-desc'>
                    {strToArray.splice(0, 2).map(item => (<li key={item}>{item}</li>))}
                </ol>
            </>
        } else {
            return <ol id='table-desc'>
                {strToArray.map(item => (<li key={item}>{item}</li>))}
            </ol>

        }
    }

    // const convertDates = (openingDate) => {
    //     let date = new Date(openingDate);
    //     let year = date.getFullYear();
    //     let month = date.getMonth() + 1;
    //     let day = date.getDate();
    //     let dateString = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`;

    //     return moment(dateString).format("DD MMM YYYY");
    // }

    const convertDates = (openingDate) => {
        const date = new Date(openingDate);
        
        // Use UTC methods to avoid timezone conversion
        const year = date.getUTCFullYear();
        const month = date.getUTCMonth() + 1;
        const day = date.getUTCDate();
        
        // Format as YYYY-MM-DD
        const dateString = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
        
        // Parse as UTC date
        return moment.utc(dateString).format("DD MMM YYYY");
    }

    const convertDateTime = (value) => {
        if (!value) return '-';
        const m = moment(value);
        return m.isValid() ? m.format('DD MMM YYYY, hh:mm A') : '-';
    };

    const generateReport = () => {
        setLoading(true);
        setOpenCustomReport(false);
        let brands = []
        inputValue.brand.forEach(item => {
            brands.push(item.brand_id)
        })
        let stores = []
        inputValue.store.forEach(item => {
            stores.push(item.store_id)
        })
        let reqBody = {
            from_date: toUTCStartOfDay(startDate),
            to_date: toUTCEndOfDay(endDate),
            brand: brands,
            store: stores,
            report: "Sales",
            service: "good_sales",
            // reco_type: inputValue?.recon?.value
        }
        CreateCustomReconReport(reqBody, USER_TOKEN).then(response => {
            if (response.status === 200) {
                ToastSuccessService('We are processing the reports in background, you can check after sometime for the report.')
            }
        }).catch(error => {
            console.log(error)
        }).finally(() => {
            setLoading(false);
        })

    }

    const downloadCustomReport = (data) => {
        let param = `?id=${data.id}`
        downloadConsolidatedReports(param);
    }

    const onClickInfo = (id) => {
        setViewAllInfo(true);
        const selectedRow = customReportData?.find(item => item?.id === id);
        setSelectedItem(selectedRow)
    }

    const downloadConsolidatedReports = (params) => {
        DownloadConsolidatedReportList(params, USER_TOKEN).then(response => {
            if (response.data.statusCode === 200) {
                window.open(response.data.presignedFileUrl, '_blank');
                ToastSuccessService('Recon report downloaded successfully.');
            } else if (response.data.statusCode === 400) {
                ToastErrorService(response.data.message);
            }
        }).catch(error => {
            if (error.response.status === 401) {
                history.push('/')
            }
            ToastErrorService(error.response.data.message);
        }).finally(() => {
            setLoading(false);
        })
    }

    const openCalendar = () => {
        setCalendarOpen(prev => !prev)
    }

    const onSelectValue = (event, name) => {
        const {
            target: { value },
        } = event;
        if (name === 'store') {
            let storeObject = [];
            value.map(storeName => {
                const selectedStore = storeNameListForCustom?.find(store => store?.value === storeName);
                let storeSelected = {
                    store_id: selectedStore?.store_id,
                    store_trade_name: selectedStore?.store_trade_name !== 'null' ? selectedStore?.store_trade_name : selectedStore?.label,
                    store_code: selectedStore?.store_code,
                    store_name: selectedStore?.label
                }
                storeObject.push(storeSelected);
            }).filter(storeName => storeName);
            setInputValue(values => ({
                ...values, 'store': storeObject,
            }));

        } else if (name === 'brand') {
            let brandObject = [];
            let brandIdsObject = [];
            value.map(brandName => {
                const selectedBrand = brandNameList?.find(brand => brand?.value === brandName);
                let brandSelected = {
                    brand_name: selectedBrand?.label,
                    brand_id: selectedBrand?.brand_id
                }
                brandObject.push(brandSelected);
                brandIdsObject.push(brandSelected?.brand_id);
            }).filter(brand => brand);
            setInputValue(values => ({
                ...values, 'brand': brandObject, store: []
            }));
            getStoreListForCustom(brandIdsObject)
        }
    }

    const getStoreListForCustom = (brandNameQueryParm) => {
        let queryParams = `?brand_id=${brandNameQueryParm ? brandNameQueryParm?.join(',') : ''}`;
        GetStoreCustomerNameList(queryParams, USER_TOKEN).then(response => {
            let dropdownData = [];
            response?.data?.data?.map(item => {
                let row = {
                    label: item?.store_trade_name ?? item?.customer_name,
                    value: item?.store_code,
                    store_code: item?.store_code,
                    store_id: item?._id,
                    store_trade_name: item?.store_trade_name
                }
                dropdownData.push(row);
            })
            setStoreNameListForCustom(dropdownData);
        }).catch(error => {
            console.log(error)
        });
    }


    const convertDate = (createdDate) => {
        let date = new Date(createdDate);
        // Extract the date part
        let year = date.getFullYear();
        let month = date.getMonth() + 1; // Month is zero-based, so we add 1
        let day = date.getDate();

        // Create a new date string in the format YYYY-MM-DD
        let dateString = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`;
        return moment(dateString).format("DD-MMM-YYYY");
    }

    const handleDateRangeChange = (key, value, optionsList, index) => {

        const ONE_DAY = 1;
        const TWO_MONTHS = 60

        const dayDifference = startDate ? differenceInDays(value, startDate) : null;
        if (!startDate || (startDate && endDate)) {
            setStartDate(value);
            setEndDate(null);
            setSelectedRange([value, null]);
        } else if (startDate && !endDate && value >= startDate) {
            if (dayDifference >= ONE_DAY && dayDifference <= TWO_MONTHS) {
                setEndDate(value);
                setSelectedRange([startDate, value]);
                setInputValue(prevState => ({
                    ...prevState,
                    from_date: startDate,
                    to_date: value
                }));
            } else {
                ToastErrorService('Please select the date up to 60 days')
            }
        } else if (startDate && !endDate && value < startDate) {
            setStartDate(value);
            setSelectedRange([value, null]);
        }
    };

    const onClickSendEmail = () => {
        setLoading(true);
        let reqBody = {
            stores_info: [],
            file_ids: []
        }
        selectedRows.forEach(item => {
            let store = {
                "store_id": item?.storeId,
                "brand_id": defaultBrand?.value,
                "brand_name": defaultBrand?.label,
                "store_name": item?.nameStore,
                "store_email": item?.email,
                "report": "Sales",
                "service": "recon",
                "view_range": selectedMonthYear
            }
            reqBody.stores_info.push(store)
        })
        selectedItems.forEach(item => {
            let row = {
                "id": item,
                "service": "recon"
            }
            reqBody.file_ids.push(row)
        })
        SendReconReportByEmail(reqBody, USER_TOKEN).then(response => {
            ToastSuccessService('Email sent successfully.', 1)
            if (gridApi) {
                gridApi.deselectAll();
            }
            setSelectedRows([]);
        }).catch(error => {
            ToastErrorService(error?.response?.data?.message)
        }).finally(() => {
            setLoading(false);
        })
    }

    const onSelectionChanged = (params) => {
        const selectedNodes = params.api.getSelectedNodes(); // Get selected nodes
        const selectedData = selectedNodes.map(node => node.data); // Get selected rows' data
        setSelectedRows(selectedData);
    };

    // const onReconSelection = (e, value) => {
    //     setInputValue(values => ({
    //         ...values, 'recon': value, brand: [], store: []
    //     }));
    // }

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setSelectedItems(customReportData.map(item => item.id)); // Ensure `item.id` exists
        } else {
            setSelectedItems([]);
        }
    };

    const handleCheckboxChange = (id) => {
        setSelectedItems(prev =>
            prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
        );
    };

    const onUpdateAllRecon = (event) => {
        let param = `?&brand=${selectedBrand?.value}&report=Sales&service=recon&view_range=${selectedMonthYear}`;
        
        RefreshAllReconReports(param, USER_TOKEN).then(response => {
            if (response.data.statusCode === 200) {
                ToastSuccessService('Reports are being refreshed, please check after sometime.');
            } else if (response.data.statusCode === 400) {
                ToastErrorService(response.data.message);
            }
        }).catch(error => {
            if (error.response.status === 401) {
                history.push('/')
            }
            ToastErrorService(error.response.data.message);
        }).finally(() => {
            setLoading(false);
        })
    }

    const isAllSelected = customReportData.length > 0 && selectedItems.length === customReportData.length;

    return (
        <div className='notoSansFont'>
            <div className='d-flex justify-content-end'>
                <div className='d-flex align-items-center first-filter'>
                    <div className='position-relative min-w-150'>
                        <button className='d-flex statusFilter cursorPointer align-items-center justify-content-between me-3'
                            onClick={handleBrandClick}>
                            <p className='text-truncate' title={selectedBrand.label}>{selectedBrand?.label}</p>
                            <img className={`${openBrandFilter ? 'transform180 pe-2' : 'ps-2'}`} src={dropDownIcon} alt="" />
                        </button>
                        <CustomFilterSearchDropdown customClass='upload-file' data={brandList} handleClose={handleBrandClose} open={openBrandFilter} anchorEl={anchorElForBrand}
                            onChange={onSelectBrand} selectedValue={selectedBrand?.value} category={'Brand'}
                            dropSearchValue={dropSearchValue} setdropSearchValue={setdropSearchValue} handleSearchChange={handleSearchChange} />
                    </div>
                </div>
                <div className='position-relative'>
                    <CustomMonthYearPicker maxDateRange={dayjs()} disabled={false} value={selectedMonthYear} defaultValue={dayjs(selectedMonthYear)} onDateChange={(newValue) => onMonthSelect(newValue)} required customClass={'customeClass'} />
                </div>
            </div>
            <div className='reportTableList'>
                {selectedTab === 1 && (
                    <div>
                        <div className='d-flex justify-content-between align-items-center montSerratFont' >
                            <div className="d-flex">
                                <div role="button" className={`fontSize18 pt-3 pb-2 mb-3 ${selectedTab === 1 ? 'selected-tab': ''}`} onClick={()=> setSelectedTab(1)}>Recon Report</div>
                                <div role="button" className={`fontSize18 pt-3 pb-2 mb-3 ms-3 ${selectedTab === 2 ? 'selected-tab': ''}`} onClick={()=> setSelectedTab(2)}>Custom Recon Report</div>
                            </div>
                            <div className='ms-auto'><CustomBlueButton onClick={onUpdateAllRecon} title='Update All' /></div>
                            <div className='ms-3'><CustomBlueButton onClick={onClickSendEmail} title='Send Email' /></div>
                        </div>
                        <div className='tableContainer reports'>
                            <CustomTableWithFilter onFilterChanged={onFilterChanged} totalRow={() => { }} onMouseOver={onMouseOver} onMouseOut={onMouseOut} onClickDownloadReport={downloadReport} onSelectionChanged={onSelectionChanged} column={ReconReportHeader} tableRowData={reconReportTableData} onClickView={null} onGridReady={onGridReady} filterModel={null} customeHeightClass={'tableCustomeHeightClass'} />
                            {hoverInfo && createPortal(
                                <div
                                    ref={tooltipRef}
                                    className="hoverTooltip"
                                    style={{
                                    border: '1px solid #cecccc',
                                    position: 'fixed',
                                    top: tooltipPos.top,
                                    left: tooltipPos.left,
                                    visibility: tooltipPos.ready ? 'visible' : 'hidden',
                                    zIndex: 99999,
                                    pointerEvents: 'none',
                                    backgroundColor: '#e4e2e2',
                                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
                                    borderRadius: '6px',
                                    padding: '8px 12px',
                                    width: '350px',
                                    maxWidth: 'calc(100vw - 16px)',
                                    fontSize: '16px',
                                }}
                                >
                                    <div><strong>{hoverInfo.data?.reconData[0]?.store_trade_name}</strong></div>
                                    <hr />
                                    <div>Total Valid CN: <strong className="ms-auto">{hoverInfo.data?.reconData[0].total_valid_cn}</strong></div>
                                    <div>Total Valid Receivable: <strong className="ms-auto">{hoverInfo.data?.reconData[0].total_payment_receviable}</strong></div>
                                    <div>Total Store Promotion: <strong className="ms-auto">{hoverInfo.data?.reconData[0].total_store_promo}</strong></div>
                                    <div>Total System Promotion: <strong className="ms-auto">{hoverInfo.data?.reconData[0].total_system_promo}</strong></div>
                                </div>,
                                document.body
                            )}
                        </div>
                    </div>
                )}
                {selectedTab === 2 && (
                    <div>
                        <div className='montSerratFont fontSize18 d-flex justify-content-between align-items-center'>
                            <div className="d-flex">
                                <div role="button" className={`fontSize18 pt-3 pb-2 mb-3 ${selectedTab === 1 ? 'selected-tab': ''}`} onClick={()=> setSelectedTab(1)}>Recon Report</div>
                                <div role="button" className={`fontSize18 pt-3 pb-2 mb-3 ms-3 ${selectedTab === 2 ? 'selected-tab': ''}`} onClick={()=> setSelectedTab(2)}>Custom Recon Report</div>
                            </div>
                            <CustomBlueButton title={'Create Custom Report'} onClick={onClickCreateCustomReport} />
                        </div>
                        <div className='tableContainer reports'>
                            {/* <CustomTableWithFilter totalRow={() => { }} isContentLeftRightFixed={false} height={450} column={salesCustomTableHeader} tableRowData={customReportData} onClickDownloadReport={downloadCustomReport} onClickView={onClickView} onFilterChanged={onFilterChanged} onGridReady={onGridReady} filterModel={tableFilterValue} customeHeightClass={'tableCustomeHeightClass'} /> */}
                            <div className=''>
                                <div className='table-row table-row-header align-items-center border-bottom'>
                                    {/* <Checkbox
                                        size='small'
                                        sx={{ width: 16, height: 16, p: 0 }}
                                        checked={isAllSelected}
                                        onChange={handleSelectAll}
                                        indeterminate={selectedItems.length > 0 && !isAllSelected}
                                    /> */}
                                    <div className='w-60 fw-bold fontSize13'>Description</div>
                                    <div className='w-20 fw-bold fontSize13'>Created On</div>
                                    <div className='w-20 fw-bold fontSize13'>Action</div>
                                </div>
                                <div className='table-cont custom-report'>
                                    {customReportData.map(item => (<div className={`table-row ps-0 ${selectedItems.includes(item.id) ? 'selected-row' : ''}`} key={item}>
                                        {/* <Checkbox size='small'
                                            sx={{ width: 16, height: 16, p: 0 }}
                                            checked={selectedItems.includes(item.id)}
                                            onChange={() => handleCheckboxChange(item.id)}
                                        /> */}
                                        <div className='ps-3 custom-report w-60 fontSize12'>{displayDescription(item, 'table')}</div>
                                        <div className='ps-1 custom-report w-20 fontSize12 d-flex align-items-center'>{convertDateTime(item.created_at)}</div>
                                        <div className='d-flex w-20'>
                                            <div className="h100 actionBtnContainer">
                                                <button title="Download" className={`tableActionButtons d-flex align-items-center justify-content-center passReport`}
                                                    onClick={() => downloadCustomReport(item)}>
                                                    <img src={DownloadIcon} alt="" />
                                                </button>
                                                <button onClick={() => onClickInfo(item.id)}>
                                                    <InfoOutlined />
                                                </button>
                                            </div>
                                        </div>
                                    </div>))}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <div className='pt-3'>

                {/* <div className='paddingTop16 d-flex justify-content-end customPagination'>
                    <CustomPagination onClick={handlePageChange} activePage={selectedPage} pageSize={20} currentPage={selectedPage} totalItems={totalCount} />
                </div> */}
            </div>

            {/* File Uploaded Successfully Modal */}
            <SuccessPopup open={openSuccessPopup} closable={false} onClose={() => setOpenSuccessPopup(false)} content={<div>
                <div className='paddingTop32 text-center'>
                    <div className='textColorBlack fontSize24 montserratFont fontMedium'>File Uploaded Successfully!</div>
                    <div className='fontSize12 textColor333'>We will be processing the data in background, you can continue with your work.</div>
                </div>
            </div>} />

            {/* create custom report */}
            <CustomModal classes="customeProgressModal" open={openCustomReport} style={uploadedFileModalStyle} handleClose={null}
                content={<div>
                    <div className='d-flex align-items-center'>
                        <div className='montSerratFont fontSize18 textColorBlack position-relative d-flex w-100'>
                            <div>Generate Custom Report</div>
                            <button className='uploadFileModalCloseIcon cursorPointer' onClick={() => setOpenCustomReport(false)}>
                                <img src={CloseIcon} alt="" />
                            </button>
                        </div>
                    </div>
                    <div className='d-flex paddingTop24 align-items-center justify-content-between'>
                        <div className='d-flex gap-2'>
                            {/* <div style={{ width: '250px' }}>
                                <CustomAutoComplete disabled={false} onChange={onReconSelection} required options={ReconType} value={inputValue?.recon} label='Recon Type*' />
                            </div> */}
                            <div style={{ width: '250px' }}>
                                <MultiSelectCheckBox MenuProps={MenuProps} errored={false} errorMsg={''} selectedValue={inputValue?.brand?.map(brand => brand?.brand_name)} handleChange={(e) => onSelectValue(e, 'brand')} required options={brandNameList} label='Brand Name*' />
                            </div>
                            <div style={{ width: '250px' }}>
                                <MultiSelectCheckBox MenuProps={MenuProps} errored={false} errorMsg={''} selectedValue={inputValue?.store?.map(stores => stores?.store_code)} handleChange={(e) => onSelectValue(e, 'store')} required options={storeNameListForCustom} label='Store Name*' />
                            </div>
                        </div>
                    </div>
                    <div style={{ width: '270px' }} className='mt-2'>
                        <div className='inputDateRangeBottomSpace'>
                            <button onClick={openCalendar} className='open_calendar_open p-0'>
                                <InputTextField
                                    type='text'
                                    disabled={false}
                                    name='dateRange'
                                    value={
                                        startDate || endDate
                                            ? `${startDate ? convertDate(startDate) : ''} ${(startDate && endDate) ? '-' : ''} ${endDate ? convertDate(endDate) : ''}`
                                            : ''
                                    }
                                    onChange={() => { }}
                                    required
                                    minLength={10}
                                    maxLength={10}
                                    label='Date'
                                    calendarIcon={true}
                                />
                            </button>
                            <div className=''>
                                <CustomDateRangePicker
                                    startDate={startDate}
                                    endDate={endDate}
                                    calendarOpen={calendarOpen}
                                    selectedRange={selectedRange}
                                    handleSelect={(date, newVal) => handleDateRangeChange('dateRange', date, '', '')}
                                    closeOnOutSide={() => setCalendarOpen(false)}
                                    restrictFutureDates={true}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='paddingTop24 d-flex justify-content-center'>
                        <div className='widthFit'>
                            <CustomBlueButton customCreatePropsBtnClass="custom-close-btn" disabled={inputValue.brand === '' || inputValue.store === '' || inputValue.from_date === null || inputValue.to_date === null} onClick={generateReport} title={'Generate Report'} />
                        </div>
                    </div>
                </div>} />
            {/* view all info */}
            <CustomModal classes="customeProgressModal" open={viewAllInfo} style={viewReportFileModalStyle} handleClose={null}
                content={<div>
                    <div className='d-flex align-items-center'>
                        <div className='montSerratFont fontSize18 textColorBlack position-relative d-flex w-100'>
                            <div className=''>Report Details <span className='fontSize14'>({convertDates(selectedItem.from_date)} - {convertDates(selectedItem.to_date)})</span></div>
                            <button className='uploadFileModalCloseIcon cursorPointer' onClick={() => setViewAllInfo(false)}>
                                <img src={CloseIcon} alt="" />
                            </button>
                        </div>
                    </div>
                    <div className='custom-height custom-report'>
                        <div className='' >{displayDescription(selectedItem, 'popup')}</div>
                    </div>
                </div>} />
            {loading && <Loader />}
        </div>
    )
}

export default ReconReport